import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { completeInitialPasswordSetup, logout } from "../common/api/auth";
import { useToast } from "../hooks/useToast";

function SetInitialPassword() {
  const location = useLocation();
  const navigate = useNavigate();
  const toast = useToast();

  const [username, setUsername] = useState(() => {
    const stateUsername = location.state?.username;
    if (stateUsername) {
      sessionStorage.setItem("pending_user", stateUsername);
      return stateUsername;
    }
    return sessionStorage.getItem("pending_user") || "";
  });

  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (location.state?.username && location.state.username !== username) {
      sessionStorage.setItem("pending_user", location.state.username);
      setUsername(location.state.username);
    }
  }, [location.state?.username, username]);

  useEffect(() => {
    if (!username) {
      toast.error("Tu sesión ha expirado. Inicia sesión nuevamente.");
      navigate("/login", { replace: true });
    }
  }, [username, navigate, toast]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    const trimmedNewPassword = newPassword.trim();
    const trimmedConfirmPassword = confirmPassword.trim();

    if (!trimmedNewPassword || !trimmedConfirmPassword) {
      toast.error("Debes introducir y confirmar la nueva contraseña.");
      return;
    }

    if (trimmedNewPassword !== trimmedConfirmPassword) {
      toast.error("Las contraseñas no coinciden.");
      return;
    }

    try {
      setIsSubmitting(true);
      const response = await completeInitialPasswordSetup(username, trimmedNewPassword);

      if (!response || response.status !== "OK") {
        throw new Error("No se pudo establecer la contraseña.");
      }

      toast.success("Contraseña creada correctamente. Inicia sesión con tu nueva contraseña.");
      sessionStorage.removeItem("pending_user");
      await logout();
      navigate("/login", { replace: true });
    } catch (error) {
      console.error("Error al crear la contraseña inicial:", error);
      toast.error(error.message || "No se pudo establecer la contraseña. Inténtalo nuevamente.");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = async () => {
    sessionStorage.removeItem("pending_user");
    await logout();
    navigate("/login", { replace: true });
  };

  return (
    <section className="cuerpo_login">
      <form className="login" onSubmit={handleSubmit}>
        <span className="logo">
          <img src="/logo.svg" alt="marca_agua_bigrid" />
        </span>

        <span className="titulo">Crea tu contraseña</span>

        <p className="descripcion" style={{marginLeft: "20px"}}>
          Hola <strong>{username}</strong>,<br/>Debes crear una contraseña antes de poder utilizar la plataforma.
        </p>

        <div className="input-group">
          <label className="label" htmlFor="newPassword">
            Nueva contraseña
          </label>
          <input
            className="input"
            type="password"
            id="newPassword"
            value={newPassword}
            onChange={(event) => setNewPassword(event.target.value)}
            autoComplete="new-password"
          />

          <label className="label" htmlFor="confirmPassword">
            Confirmar contraseña
          </label>
          <input
            className="input"
            type="password"
            id="confirmPassword"
            value={confirmPassword}
            onChange={(event) => setConfirmPassword(event.target.value)}
            autoComplete="new-password"
          />
        </div>

        <div className="checkbox" style={{ justifyContent: "center", gap: "1rem" }}>
          <button className="boton_login" type="submit" disabled={isSubmitting}>
            {isSubmitting ? "Guardando..." : "Guardar contraseña"}
          </button>
          <button className="boton_cancelar" type="button" onClick={handleCancel} disabled={isSubmitting}>
            Cancelar
          </button>
        </div>
      </form>
    </section>
  );
}

export default SetInitialPassword;